<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-card class="mx-aut" flat>
                <v-card-text>
                    <v-layout class row>
                        <v-flex xs12 md12>
                            <v-textarea
                                :label="$vuetify.lang.t('$vuetify.places_to_visit_in_nepal') + ' *'"
                                outlined
                                type="text"
                                :rules="[rules.required]"
                                v-model="visa.extra.application_data.places_to_visit"
                            />
                        </v-flex>

                    </v-layout>
                </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import DatePicker from "../../DatePicker";

    export default {
        data: () => ({
            addressLoading: false,
            rules: {
                required: value => !!value || "Required."
            },
        }),
        components: {
            DatePicker, ConfirmationHeaderText,
            "address-auto-complete": AddressAutoComplete
        },
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            }
        },

    };
</script>

<style>
</style>
